import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import { styles } from './ButtonStyles';

export default class Button extends Component {
  render() {
    return (
      <button className={css(styles.button)} type={this.props.type}>
        {this.props.title}
      </button>
    );
  }
}
